import React, { useState } from 'react';
import {
  AnimatePresence,
  motion,
  useMotionValueEvent,
  useReducedMotion,
  useScroll,
} from 'framer-motion';

const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const { scrollY } = useScroll();
  const reducedMotion = useReducedMotion();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    setVisible(latest > 600);
  });

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          aria-label="Back to top"
          initial={{ opacity: 0, scale: 0.5, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 16 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' })}
          className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg"
        >
          <i className="bx bx-chevron-up text-3xl"></i>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
